<template>
  <div class="box">
    <Header :active="active" />
    <Banner />

    <div class="list">
      <div class="inner">
        <div class="publictitle">
        <p class="pli">咨询师团队</p>
        <!-- <p class="pli1">Consultation expert group</p> -->
      </div>
      
        <!-- <div style="margin-bottom: 20px">
          首页><span class="titles">咨询师团队</span>
        </div> -->
        <!-- <img class="publicimg" src="../assets/images/2.png" alt="" /> -->
        <div class="mrs">
          <el-radio-group @change="changeType" v-model="type">
             <el-radio-button class="net" label="3">总督导师</el-radio-button>
            <el-radio-button class="net" label="2">高级心理咨询师</el-radio-button>
            <el-radio-button class="net" label="1">中级心理咨询师</el-radio-button>
            <el-radio-button class="net" label="0">初级心理咨询师</el-radio-button>
          </el-radio-group>
        </div>
        <div :class="type=='3'?'df':''" class="forlist clearfix">
          <div v-for="(item, index) in list" :key="index" class="for">
            <img :src="item.img" alt="" />
            <div class="bold">
              <div
                style="
                  font-weight: bold;
                  line-height: 38px;
                  color: #3c93d6;
                  font-size: 18px;
                "
              >
                {{ item.name }}
              </div>
              <div @click="goTeamInner(item)" class="kan">查看详情</div>
            </div>
          </div>
        </div>
        <!-- <div class="pages">
          <el-pagination
            @current-change="loadData"
            layout="prev, pager, next"
            :page-count="size"
            :current-page="page"
          >
          </el-pagination>
        </div> -->
      </div>
    </div>
    <Map ref="map" />
    <Foot />
    <Right />
  </div>
</template>

<script>
import Right from "../components/Right.vue";
import Header from "../components/header.vue";
import Banner from "../components/banner.vue";
import Map from "../components/map.vue";
export default {
  components: {
    Header,
    Right,
    Banner,
    Map,
  },
  data() {
    return {
      active: 1,
      page: 1,
      size: 1,
      list: [],
      linkList: [],
      phone: null,
      map: null,
      type: 3,
    };
  },
  computed: {},
  created() {},
  beforeDestroy() {
    this.$refs.map.destroy();
  },
  mounted() {
    this.getTeam();
  },
  methods: {
    goTeamInner(item) {
      sessionStorage.setItem("team", JSON.stringify(item));
      this.$router.push(`/teaminner`);
    },
    getTeam() {
      var data = {
        limit:10000,
        page: this.page,
        type:this.type
      };
      this.$get("/web/api/get_list_team", data).then((res) => {
        if (res.code == 200) {
          console.log(res.data.list);
          this.size = res.data.size;
          this.list = res.data.list;
        }
      });
    },
    loadData(e) {
      this.page = e;
      this.getTeam();
    },
    changeType(e){
      this.page=1
      this.type=e
       this.getTeam();
    }
  },
};
</script>

<style  scoped>
.publicimg {
  margin: 0 auto 30px;
  display: block;
}

.list {
  padding: 25px 0 50px 0;
}
.titles {
  color: #2c87ce;
}
.for {
  width: 300px;
  box-sizing: border-box;
  border: 1px solid #c9e7ff;
  float: left;
  margin-bottom: 10px;
  margin-right: 10px;
}
.forlist > div:nth-child(4n) {
  margin-right: 0;
}
.for img {
  display: block;
  width: 275px;
  height: 275px;
  border-radius: 50%;
  margin: 10px auto 20px;
}
.bold {
  padding: 0 10px;
  text-align: center;
}
.content {
  padding: 0 10px 18px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #6d6d6d;
  font-size: 14px;
}
.pages {
  display: flex;
  justify-content: center;
}
.liucheng {
  display: block;
  width: 1020px;
  margin: 0 auto;
}
.fl {
  justify-content: space-between;
  display: flex;
}
#container {
  display: block;
  width: 660px;
  height: 270px;
}
.dar {
  padding: 50px 0 22px;
  border-bottom: 1px solid #7d7d7d;
  font-size: 24px;
}
.kan {
  width: 144px;
  margin: 7px auto 14px;
  border: 1px solid #3c93d6;
  padding: 5px 0;
  border-radius: 5px;
  cursor: pointer;
  background-color: #3c93d6;
  color: #fff;
}
.mrs {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 50px;
}
.df{
  display: flex;
  justify-content: center;
}

.df .for{
  margin-right: 0;
}

</style>